import { isUndefined } from 'lodash';
import { Loader } from 'components/Loader';
import { StructuredActivityUI } from 'domains/structuredActivities/Page/ui';
import { StructuredActivityCtx } from 'domains/structuredActivities/context';
import { useStructuredActivity } from 'domains/structuredActivities/data';
import { STRUCTURED_ACTIVITY_STEPPER_TITLES } from 'domains/structuredActivities/steps';
import { useCompletableWizard } from 'utils/hooks/useCompletableWizard';
import { AssignmentFeedback, StructuredActivityAssociatedMaterial } from 'domains/assignments/types';

type Props = {
  structuredActivityId: string;
  associatedMaterial?: StructuredActivityAssociatedMaterial;
  onSubmit: (feedback: AssignmentFeedback) => void;

  previewMode?: boolean;
};

export const StructuredActivity: React.FC<Props> = ({
  structuredActivityId,
  onSubmit,
  associatedMaterial,
  previewMode = false,
}) => {
  const { data: content, error, isLoading: isLoadingContent } = useStructuredActivity(structuredActivityId);

  const wizard = useCompletableWizard(Object.keys(STRUCTURED_ACTIVITY_STEPPER_TITLES).length);

  if (isLoadingContent) {
    return <Loader defaultStyles />;
  }

  if (isUndefined(content)) {
    throw new Error(`Failed to fetch data for ADL ID: ${structuredActivityId}. Error was ${error}`);
  }

  return (
    <StructuredActivityCtx.Provider
      value={{
        ...wizard,
        previewMode,
        associatedMaterial,
        structuredActivityContent: content,
        onComplete: onSubmit,
      }}
    >
      <StructuredActivityUI />
    </StructuredActivityCtx.Provider>
  );
};

export default StructuredActivity;
